import React from "react";
import NewPaymentAddPayment from "../NewPayment/addPayment";

const GaragePaymentAddPayment = (props) => {
  const garages = props.garages || [];

  const translateGarage = (key) => {
    if (key === "contractNumber") return props.translate("searchGarage");
    return props.translate(key);
  };

  const selectedGarage = props.selectedAccount
    ? {
        ...props.selectedAccount,
        accountName:
          props.selectedAccount.accountName ||
          props.selectedAccount.name ||
          props.selectedAccount.label,
      }
    : props.selectedAccount;

  return (
    <NewPaymentAddPayment
      {...props}
      translate={translateGarage}
      accounts={garages}
      selectedAccount={selectedGarage}
      searchGarageOptions={props.searchGarageOptions}
    />
  );
};

export default GaragePaymentAddPayment;
